import React, { useState, useContext, useEffect } from "react";
import { TokenContext } from "./TokenContext";
import Repo from "../Utility/Repo";
import { Input } from "design-react-kit";

function MedicoInputComponent({ cartellaSocialeId, medico }) {
  const apiToken = useContext(TokenContext);
  const [nomeMedico, setNomeMedico] = useState(medico);

  const handleSave = () => {
    Repo.postMedicoCurante(apiToken, cartellaSocialeId, nomeMedico)
      .then(() => {
        window.location.reload();
      })
      .catch((error) => {
        console.error(error);
      });
  };

  return (
    <>
      <div className="row justify-content-center">
        <div className="alert alert-warning text-center col-8" role="alert">
          Per procedere è necessario inserire il medico curante, in alternativa
          inserire un <strong>trattino</strong> nell'apposito campo.
        </div>
      </div>
      <div className="col-lg-12 mt-2">
        <div className="row">
          <div className="col-2 mt-2">
            <strong>Dott./Dott.ssa</strong>
          </div>
          <div className="col-10">
            <Input
              id="medico"
              label="Medico Curante"
              type="text"
              name="medico"
              value={nomeMedico}
              onChange={(e) => setNomeMedico(e.target.value)}
            />
          </div>
        </div>
      </div>
      <button
        className="btn btn-primary btn-salva ml-4"
        type="button"
        onClick={handleSave}
      >
        Salva medico
      </button>
    </>
  );
}

export default MedicoInputComponent;
